var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-form",
    { attrs: { size: "small" } },
    [
      _c(
        "sui-grid",
        [
          _c(
            "sui-grid-row",
            [
              _c(
                "sui-grid-column",
                [
                  _c("sui-form-field", [
                    _c("label", [_vm._v("Model Name")]),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.name,
                          expression: "model.name",
                        },
                      ],
                      attrs: {
                        type: "text",
                        name: "model-name",
                        placeholder: "Model Name",
                      },
                      domProps: { value: _vm.model.name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.model, "name", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }